<template>
    <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul>
            <li v-for="user in users" :key="user.id">
                <div class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
                    <div class="flex items-center px-4 py-4 sm:px-6">
                        <div class="min-w-0 flex-1 flex items-center">
                            <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                                <div>
                                    <div class="text-sm leading-5 font-medium text-indigo-600 truncate">{{ user.first_name }} {{ user.last_name }}</div>
                                    <div class="mt-2 flex items-center text-sm leading-5 text-gray-500">
                                        <icon name="email" class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"></icon>
                                        <span class="truncate">{{ user.email }}</span>
                                    </div>
                                    <div class="mt-2 flex items-center text-sm leading-5 text-gray-500">
                                        <icon name="phone-call" class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"></icon>
                                        <span class="truncate">{{ user.mobile }}</span>
                                    </div>
                                  <div class="mt-1">
                                    <a href="#" class="px-2 py-1 text-sm text-gray-600bg-gray-400 rounded hover:bg-gray-500 hover:text-white" @click.prevent="showUserModal(user)">show user linked accounts</a>
                                  </div>
                                </div>
                                <div class="hidden md:block">
                                    <div>
                                        <div class="text-sm leading-5 text-gray-900">
                                            Applied on
                                            <time>{{ user.created_at | localDateTime }}</time>
                                        </div>
                                        <div class="mt-2 flex items-center text-sm leading-5 text-gray-500">
                                          <span class="text-orange-500" v-if="user.pivot.approved == 0">
                                            PENDING APPROVAL
                                          </span>
                                          <span v-else class="text-green-500">
                                            Approved
                                          </span>
                                        </div>
                                      <div class="mt-2">
                                        <p class="text-xs font-bold">Apply action</p>
                                        <user-action-form :customer-id="customerId" :user="user" />
<!--                                        <div class="flex flex-row text-sm py-2">-->
<!--                                          <form method="post" :action="route('customer-account-user-action', {customer: customerId, user: user.id})">-->
<!--                                            <select name="action" class="border border-gray-400 p-1 rounded mr-2">-->
<!--                                              <option>-&#45;&#45;</option>-->
<!--                                              <option v-if="user.pivot.approved == 0" value="approve">Approve</option>-->
<!--                                              <option v-else value="unlink">Unlink</option>-->
<!--                                            </select>-->
<!--                                            <button type="submit" class="bg-gray-200 border-gray-100 border hover:bg-gray-100 hover:border-gray-200 text-xs px-2 py-1 rounded">Update</button>-->
<!--                                          </form>-->
<!--                                        </div>-->
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import Icon from '@/Shared/Icon'
    import UserActionForm from './UserActionForm'

  export default {
    name: 'CustomerUsers',
    components: {
      Icon,
      UserActionForm
    },
    props: {
      users: Array,
      customerId: Number
    },
    methods: {
      showUserModal(user) {
        this.$emit('onShowUserModel', user);
      }
    }
  }
</script>
